import type { GameModule } from '../types';
import Page from './Page';
import RotatePrompt from './RotatePrompt';

const rummy: GameModule = {
  id:          'rummy',
  displayName: 'Rummy',
  tag:         'Cards',
  theme: {
    gradient: 'from-green-600 via-green-800 to-green-950',
    emoji:    '🃏',
    logo:     '/games/rummy/Logo.png',
  },
  // Multi-seat table + fanned hand strip fit only sideways. The
  // shell locks to landscape and surfaces the rotate-prompt if the
  // hardware lock didn't take.
  orientation: 'landscape',
  // Use the bespoke rummy rotate-prompt (gold-on-emerald felt look)
  // instead of the platform-default shared-ui OrientationPrompt.
  // The themed prompt was on disk all along — see ./RotatePrompt.tsx
  // and .rummy-rotate-prompt in ./rummy.css.
  RotatePrompt,
  Page,
  adminIcon: 'style',
  adminTheme: {
    headerFrom:  'from-emerald-900',
    headerTo:    'to-green-950',
    ring:        'ring-yellow-400',
    accent:      'bg-emerald-700',
    accentHover: 'hover:bg-emerald-600',
    dot:         'bg-yellow-400',
    softBg:      'bg-emerald-900/30',
    rangeAccent: 'accent-yellow-500',
    badgeClasses: 'bg-emerald-700/20 text-yellow-300 border-emerald-700/30',
  },
};

export default rummy;
